<template lang="pug">
shListData(title="Baneos" resolver="bans" keyData="_id" component="shBan")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Bans',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ban/Bans.vue